import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px;
  gap: 20px;
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.h1`
  font-size: 2rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.black90};
`;

export const Content = styled.main`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  background: ${(props) => props.theme.colors.white100};
  border-radius: 8px;
  padding: 20px;
`;
